export default ({
  children,
  marginTop,
  marginBottom,
  paddingRight,
  wrap,
  fontSize,
  fontFamily,
  className,
  maxWidth
}) => (
  <>
    <div className="subtitle" style={{ marginTop, marginBottom, maxWidth }}>
      <span className={`title-contents has-text-weight-light ${className}`}>{children}</span>
    </div>
    <style jsx="true">{`
      .title-contents {
        font-family: ${fontFamily ? fontFamily : 'FuturaLight'};
        font-size: ${fontSize ? fontSize : '28px'};
        white-space: ${wrap ? wrap : 'auto'};
        padding-right: ${paddingRight ? paddingRight : '10px;'};
      }

      .subtitle {
        margin-top: 'auto';
        margin-bottom: ${marginBottom ? `${marginBottom} !important` : 'auto'};
        max-width: ${maxWidth ? `${maxWidth}` : 'auto'};
        display: inline-block;
      }
    `}</style>
  </>
);
